import { DownloadIcon, Trash2Icon } from "lucide-react";
import { Button, Loader } from "@monolith-forensics/monolith-ui";

import { SavedReport } from "../savedReports.types";

interface SavedReportActionsCellProps {
  report: SavedReport;
  canManage: boolean;
  onDelete: (report: SavedReport) => void;
}

export const SavedReportActionsCell: React.FC<SavedReportActionsCellProps> = ({
  report,
  canManage,
  onDelete,
}) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: 8,
      width: "100%",
    }}
  >
    {report.is_ready === 0 && (
      // Same shape as the Download button so the column does not jump when
      // the report finishes generating
      <Button
        variant="subtle"
        size="xs"
        color="primary"
        disabled
        leftSection={<Loader size={14} />}
      >
        Generating…
      </Button>
    )}
    {report.is_ready === 1 && (
      <>
        {canManage && (
          <Button
            variant="subtle"
            size="xs"
            color="primary"
            href={report.link}
            download={report.name}
            leftSection={<DownloadIcon size={14} />}
          >
            Download
          </Button>
        )}
        <Button
          variant="subtle"
          size="xs"
          color="error"
          disabled={!canManage}
          onClick={() => onDelete(report)}
          leftSection={<Trash2Icon size={14} />}
        >
          Delete
        </Button>
      </>
    )}
  </div>
);
